<template>

    <Container :fluid="fluid || fluidOnMobile" class="grid" :class="{ '--collapsed': collapsed }">

        <div class="grid__content flex"
             :class="[
                 reverseOnMobile ? 'flex-wrap-reverse md:flex-wrap' : 'flex-wrap',
                 { 'items-center': centered },
                 { '--fluid': fluid },
                 { '--fluid-on-mobile': fluidOnMobile },
             ]">

            <slot :columns="responsiveColumns"/>

        </div>

    </Container>

</template>

<script lang="ts">

    import { defineComponent, PropType, provide } from 'vue'
    import { useResponsiveValue } from '../../compositions/UseResponsiveValue'
    import Container from '../Container.vue'

    export default defineComponent({
        name: 'Grid',
        components: { Container },
        props: {
            columns: { type: [ Number, Array ] as PropType<number | number[]>, default: () => [ 2, 6 ] },
            collapsed: { type: Boolean, default: false },
            centered: { type: Boolean, default: false },
            fluid: { type: Boolean, default: false },
            fluidOnMobile: { type: Boolean, default: false },
            reverseOnMobile: { type: Boolean, default: false }
        },
        setup(props) {

            const responsiveColumns = useResponsiveValue(props.columns)

            provide('columns', responsiveColumns)

            return {
                responsiveColumns
            }

        }
    })

</script>

<style lang="scss">

    %default-grid-values {

        @screen md {

            margin-right: -20px;
            margin-left: -20px;

        }

        @screen lg {

            margin-right: -24px;
            margin-left: -24px;

        }

        @screen xl {

            margin-right: 0;
            margin-left: 0;

        }

    }

    @include component(grid) {

        @include part(content) {

            @include option(fluid) {

                @screen sm {

                    margin-right: 0;
                    margin-left: 0;

                }

            }

            @include option(fluid-on-mobile) {

                @screen sm {

                    margin-right: 0;
                    margin-left: 0;

                }

                @extend %default-grid-values;

            }

            @screen sm {

                margin-right: 10px;
                margin-left: 10px;

            }

            @extend %default-grid-values;

        }

        @include option(collapsed) {

            @screen lg {

                max-width: calc(1024px + 190px);

            }

            @screen xl {

                max-width: calc(1440px + 120px * 2);

            }

        }

    }

</style>
